import React from 'react';
import logo from './logo.svg';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import DataEntry from './pages/DataEntry';

const App = () => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname)
  }

  return (
    <Auth0Provider
      domain="meruproductions.us.auth0.com"
      clientId="oFQUE2pxMiGK9scj6dltRKFfDF7jBZKq"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience:"https://meruproductions.us.auth0.com/api/v2/"
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <Routes>
        <Route path="/" element={<ProtectedRoute component={Home} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/new-entry" element={<ProtectedRoute component={DataEntry} />} />
      </Routes>
    </Auth0Provider>
  )
}

export default App